import { getCallbackRecommendations } from './callbackRecommendations';
import { getIsFromBuilder, getIsFromSeller } from './newObject';
import { IState } from '../store';
import { isNewbuildingSelector } from './offerData/offer';

export function isCallbackRecommendationsEnabled(state: IState): boolean {
  const isNewbuilding = isNewbuildingSelector(state);
  const isFromBuilder = getIsFromBuilder(state);
  const isFromSeller = getIsFromSeller(state);
  const recommendation = getCallbackRecommendations(state);

  return Boolean(isNewbuilding && (isFromBuilder || isFromSeller) && recommendation && recommendation.length);
}
